module.exports = __webpack_public_path__ + "img/Sponga_Logo.8ca9b785.png";